import * as React from 'react'
import Svg, { Rect } from 'react-native-svg'

export const Rectangle = () => (
  <Svg width={39} height={8} viewBox='0 0 39 8' fill='none'>
    <Rect
      x={0.866028}
      y={3.87799}
      width={5.48431}
      height={5.48431}
      transform='rotate(-45 0.866028 3.87799)'
      fill='#FE5000'
    />
    <Rect
      x={15.622}
      y={3.87799}
      width={5.48431}
      height={5.48431}
      transform='rotate(-45 15.622 3.87799)'
      fill='#FE5000'
    />
    <Rect
      x={30.378}
      y={3.87799}
      width={5.48431}
      height={5.48431}
      transform='rotate(-45 30.378 3.87799)'
      fill='#FE5000'
    />
  </Svg>
)
